import React, { useState, useEffect } from "react";
import { Row, Col, Button } from "react-bootstrap";
import "./AddGuests.scss";
import { useSelector } from "react-redux";
import MinusCircleIcon from "@material-ui/icons/RemoveCircle";
import { useNavigate } from "react-router-dom";

function ErrorExists(props) {
  function handleButtonClick() {
    if (isWidgetMode()) {
      if (window.parent) {
        window.parent.postMessage({ source: "waitly", command: "dismiss" }, "*");
      }
    } else {
      navigateToWaitlist();
    }
  }
  function navigateToWaitlist() {
    navigate(`/wl/${props.hash}`);
  }

  function isWidgetMode() {
    return display && display.widgetMode !== undefined && display.widgetMode === true;
  }
  const navigate = useNavigate();
  const [buttonTitle, setButtonTitle] = useState("Show me the waitlist");
  const { display } = useSelector((state: any) => {
    return state;
  });

  useEffect(() => {
    if (display && display.widgetMode !== undefined && display.widgetMode === true) {
      setButtonTitle("OK");
    }
  }, [display]);

  var buttonStyle = {
    fontFamily: props.appearance.fontFamily,
    color: props.appearance.highlightFontColor,
    backgroundColor: props.appearance.highlightBackgroundColor,
    border: "0px"
  };

  return (
    <div className="add-guest-wrapper">
      <div className="add-guest">
        <Row>
          <Col className="add-guest__title" md={12}>
            <span style={{ fontSize: "18px" }}>
              You are already on the waitlist at a different location. Remove yourself first before joining this
              waitlist
            </span>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <div className="add-guest__error-icon">
              <MinusCircleIcon className="add-guest__icon" />
            </div>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <div className="add-guest__actions">
              <Button style={buttonStyle} onClick={handleButtonClick} type="button">
                {buttonTitle}
              </Button>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
}

export default ErrorExists;
